<div class="cd-page">
  <app-counselor-nav></app-counselor-nav>

  <main class="cd-main" aria-label="Manage User">
    @if (loading) {
      <p class="mu-loading">Loading user details...</p>
    }

    @if (!loading && errorMessage) {
      <p class="mu-loading" role="alert">{{ errorMessage }}</p>
    }

    @if (!loading && !errorMessage && !user) {
      <p class="mu-loading">User not found.</p>
    }

    @if (!loading && user) {
      <div class="mu-header">
        <div>
          <h1 class="cd-title">Manage User</h1>
          <p class="cd-subtitle">{{ displayName }} &mdash; {{ user.email }}</p>
        </div>
        <div class="mu-header-meta">
          <span class="um-badge um-badge-type">{{ user.user_type }}</span>
          <span
            class="um-badge"
            [class.um-badge-active]="user.is_active"
            [class.um-badge-inactive]="!user.is_active"
          >
            {{ user.is_active ? 'Active' : 'Inactive' }}
          </span>
        </div>
      </div>

      <section class="mu-section" aria-label="Role assignments">
        <h2 class="mu-section-title">Roles</h2>
        <p class="mu-section-desc">Assign roles to grant groups of permissions to this user.</p>

        <div class="mu-items-grid">
          @for (role of roles; track role.id) {
            <label
              class="mu-item"
              [class.mu-item-active]="hasRole(role.id)"
              [class.mu-item-disabled]="isRoleLocked(role)"
              [attr.title]="isRoleLocked(role) ? 'This role has permissions you do not hold' : null"
            >
              <input
                type="checkbox"
                [checked]="hasRole(role.id)"
                [disabled]="isRoleLocked(role)"
                (change)="toggleRole(role.id)"
                [attr.aria-label]="'Toggle role ' + role.name"
                [attr.data-testid]="'role-checkbox-' + role.id"
              />
              <div class="mu-item-content">
                <span class="mu-item-name">{{ role.name }}</span>
                @if (role.description) {
                  <span class="mu-item-desc">{{ role.description }}</span>
                }
              </div>
            </label>
          }
        </div>
      </section>

      <section class="mu-section" aria-label="Direct permission assignments">
        <h2 class="mu-section-title">Direct Permissions</h2>
        <p class="mu-section-desc">
          Assign individual permissions directly to this user, in addition to any permissions
          granted through roles.
        </p>

        <div class="mu-perm-filters">
          <input
            type="text"
            class="mu-perm-search"
            placeholder="Search permissions..."
            [(ngModel)]="permissionSearch"
            aria-label="Search permissions"
            data-testid="permission-search-input"
          />
          <select
            class="mu-perm-category"
            [(ngModel)]="permissionCategoryFilter"
            aria-label="Filter by category"
            data-testid="permission-category-filter"
          >
            <option value="">All Categories</option>
            @for (cat of permissionCategories; track cat) {
              <option [value]="cat">{{ cat }}</option>
            }
          </select>
        </div>

        <div class="mu-items-grid">
          @for (perm of filteredPermissions; track perm.id) {
            <label
              class="mu-item"
              [class.mu-item-active]="hasPermission(perm.id)"
              [class.mu-item-disabled]="isPermissionLocked(perm)"
              [attr.title]="isPermissionLocked(perm) ? 'You do not hold this permission' : null"
            >
              <input
                type="checkbox"
                [checked]="hasPermission(perm.id)"
                [disabled]="isPermissionLocked(perm)"
                (change)="togglePermission(perm.id)"
                [attr.aria-label]="'Toggle permission ' + perm.name"
                [attr.data-testid]="'permission-checkbox-' + perm.id"
              />
              <div class="mu-item-content">
                <span class="mu-item-name">{{ perm.name }}</span>
                <span class="mu-item-key">{{ perm.key }}</span>
                @if (perm.description) {
                  <span class="mu-item-desc">{{ perm.description }}</span>
                }
              </div>
            </label>
          }
        </div>

        @if (filteredPermissions.length === 0) {
          <p class="mu-empty">No permissions match your search.</p>
        }
      </section>

      @if (saveError) {
        <p class="mu-save-error" role="alert" data-testid="manage-user-save-error">
          {{ saveError }}
        </p>
      }

      <!-- ACTION BUTTONS -->
      <div class="mu-actions">
        <button
          class="mu-btn mu-btn-save"
          (click)="save()"
          [disabled]="!isDirty || saving"
          aria-label="Save changes"
          data-testid="manage-user-save-btn"
        >
          {{ saving ? 'Saving...' : 'Save Changes' }}
        </button>
        <button
          class="mu-btn mu-btn-cancel"
          (click)="cancel()"
          [disabled]="saving"
          aria-label="Cancel and go back"
          data-testid="manage-user-cancel-btn"
        >
          Cancel
        </button>
      </div>
    }
  </main>
</div>
